import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CalendarExporterFactory} from './calendar-exporter/calendar-exporter.factory';
import {CalendarExporter} from './calendar-exporter/calendar-exporter.abstract';

const calendarExporters: CalendarExporter[] = [
  {type: 'google', label: 'Google Calendar', icon: 'fa-brands fa-google'},
  {type: 'outlook', label: 'Outlook Calendar', icon: 'fa-brands fa-microsoft'},
  {type: 'yahoo', label: 'Yahoo! Calendar', icon: 'fa-brands fa-yahoo'},
  {type: 'iCalendar', label: 'iCal', icon: 'fa-light fa-calendar'},
  {type: 'vCalendar', label: 'vCalendar', icon: 'fa-light fa-calendar'}
];

@Component({
  selector: 'asax-result-table-search-table-cell-release-date',
  templateUrl: './cell-release-date.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CellReleaseDateComponent {
  @Input() releaseDate: string;
  @Input() row: any;

  calendarExporters = calendarExporters;

  constructor(private readonly calendarExporterFactory: CalendarExporterFactory) {
    this.calendarExporters = calendarExporters;
  }

  exportCalendar(calendarExporter: CalendarExporter): void {
    const calendarExporterAbstract = this.calendarExporterFactory.getCalendar(calendarExporter.type);

    if (this.row?.code) {
      calendarExporterAbstract.exportForProject(this.releaseDate, this.row?.code);
    } else if (this?.row.bibCode) {
      calendarExporterAbstract.exportForPublication(this.releaseDate, this.row?.code);
    } else if (this.row?.datasetId) {
      calendarExporterAbstract.exportForObservation(this.releaseDate, this.row?.datasetId);
    }
  }
}
